import { useEffect } from 'react';
import { Grid } from '@mui/material';
import { fetchAdmin, toErrorMessage } from '../../admin/api';
import { AdminRouteLayout, RequestState, StatCard, useAsyncState } from './AdminRoutePageShared';

export default function QueueJobsOverviewPage() {
  const overview = useAsyncState(null);

  useEffect(() => {
    const loadOverview = async () => {
      overview.setLoading();
      try {
        const response = await fetchAdmin('/ops/queues/overview');
        overview.setData(response.overview || {});
      } catch (error) {
        overview.setError(toErrorMessage(error));
      }
    };

    loadOverview();
  }, []);

  return (
    <AdminRouteLayout title="Overview" breadcrumbTitle="Queue & Jobs">
      <RequestState loading={overview.state.loading} error={overview.state.error}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <StatCard title="Queued Jobs" value={overview.state.data?.queued_jobs || 0} caption="Pending queue jobs" />
          </Grid>
          <Grid item xs={12} md={4}>
            <StatCard title="Reserved Jobs" value={overview.state.data?.reserved_jobs || 0} caption="In-flight queue jobs" />
          </Grid>
          <Grid item xs={12} md={4}>
            <StatCard title="Outbox Failed" value={overview.state.data?.outbox_failed || 0} caption="Dispatch intent failures" />
          </Grid>
        </Grid>
      </RequestState>
    </AdminRouteLayout>
  );
}
